let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g1Ytb")).then(() => parcelRequire('9QCmd'));